export function insertStyle(type, config) {
  let styles = commonCss(config);
  styles += type === 'pc' ? pcCss() : wrapCss();
  if (document.all) {
    window.style = styles;
    document.createStyleSheet("javascript:style");
  } else {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = styles;
    document.getElementsByTagName('HEAD').item(0).appendChild(style);
  }
}

export function insertDocument(dom, id, tag = 'div') {

  if (!dom) return 'document不能为空';
  if (!id) return 'className不能为空';

  const wrap = document.createElement(tag);

  wrap.id = id;
  wrap.className = id;
  wrap.innerHTML = dom;

  document.body.appendChild(wrap, document.body)
}

export function jsonp(url, name, cb) {
  window[name] = cb;
  url = `${url}&callback=${name}`;
  var script = document.createElement('script');
  script.setAttribute('src', url);
  document.getElementsByTagName('head')[0].appendChild(script);
}

export const deviceType = window.navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) !== null ? 'wap' : 'pc';;

export const formatDate = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt + '-';
}

export const parseStr = function (str) {
  const result = {
    status: false,
    data: {},
    msg: ''
  }
  if (str) {
    try {
      result.data = JSON.parse(str);
      result.status = true;
    } catch (err) {
      result.msg = err
    }
  }
  return result;
}

export const isCsFormPage = function () {
  let url = window.location;
  let isFrom = urlParse();
  if (url.pathname === "/messages/send.html" && !isFrom.view) {
    return true;
  }
  return false;
}

export const isCsSuccessPage = function () {
  let url = window.location;
  let isFrom = urlParse();
  if (url.pathname === "/messages/send.html" && isFrom.view) {
    return true;
  }
  return false;
}

export const isContainerPathname = function (pathnames) {
  if (!pathnames.length) return false;
  let url = window.location;
  return pathnames.indexOf(url.pathname) >= 0
}

export const urlParse = function (url) {
  var param = new Object()
  var item = new Array();
  if (location.search == "") {
    return param;
  };
  var query = location.search.substring(1);
  var list = query.split('&');
  for (var i = 0; i < list.length; i++) {
    item = list[i].split('=');
    if (typeof param[item[0]] == "undefined") {
      param[item[0]] = '';
    }
    param[item[0]] = item[1];
  };
  return param;
}

export const isInApp = function () {
  return /WindVane/i.test(window.navigator.userAgent);
}

export const isAndroid = (function () {
  return /Android/i.test(window.navigator.userAgent);
})();

export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'Dxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return `7${uuid.replace(/-/g,'')}UG`;
};



// WEBPACK FOOTER //
// ./src/common/utils.js